export default {
    clearLocalStorage({commit}) {
        localStorage.clear()
        commit('clearLocalStorage')
    },
    createNotification({commit}, params) {
        return new Promise(resolve => {
            params.resolve = resolve
            commit('createNotification', params)
        })
    },
    setExpiration({commit}, expiration) {
        localStorage.setItem('expiration', expiration)
        commit('setExpiration', expiration)
    },
    setLoading: ({commit}, local) => commit('setLoading', local),
    setModulos({commit}, modulos) {
        localStorage.setItem('modulos', JSON.stringify(modulos))
        commit('setModulos', modulos)
    },
    setNotification: ({commit}, params) => commit('setNotification', params),
    setSidebar({commit}, value) {
        localStorage.setItem('sidebar', value)
        commit('setSidebar', value)
    },
    setToken({commit}, token) {
        localStorage.setItem('token', token)
        commit('setToken', token)
    },
    setUsuario({commit}, usuario) {
        localStorage.setItem('usuario', JSON.stringify(usuario))
        commit('setUsuario', usuario)
    },
    unsetLoading: ({commit}) => commit('unsetLoading'),
}